import { CLASSTING_API_URL } from '../../constants';
import { http } from '../../utils';

export const updateGuardianContactNewsletter = ({ gcnid, lastOpenedAt }) => http.put(
  `${CLASSTING_API_URL}/v1/guardian_contact_newsletters/${gcnid}`,
  { last_opened_at: lastOpenedAt },
);
